import React, { useState } from "react";
import { ListCard, MapViewFlyOut } from "../Shared";
import { useGetDevicesQuery } from "../../ManagementPortal/services";
import { useGetVehiclesQuery } from "../../ManagementPortal/services";
import { useEffect } from "react";
import { FMDPStorage } from "../../../shared/helper";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "../../../shared/translation";
import { useSelector } from "react-redux";

import { setSelectionRange } from "@testing-library/user-event/dist/utils";
import Scrollbars from "react-custom-scrollbars-2";
import moment from "moment";
import { getUserIdForFiltering } from "../utils";

let list_arr = [];
export const DeviceList = ({
  setDetails,
  setDeviceId = () => {},
  setSourceIds,
  sourceIds,
  showPontOnMap,
  mapData,
  setselectedVehiclePlate,
  setselectedDeviceName,
  setHighlight,
  highlight,
  setDockAlign,
  setShowDetails,
  removeLayerOnClose,
  setMapExpand,
  setShowTrack,
  dockAlign,
  setSimpleSearch,
  simpleSearch,
  currentTab,
  setVehicleData,
  selectedRowId,
  setSelectedRowId,
  vehicleData,
  setCurrentTab = () => {},
  data = [],
  paginationVehicles,
  totalCountVehicles,
  sortedDataDisplay,
  setSortedDataDisplay,
  setPageVehicles,
  q,
  setNonAdminUserId,
  nonAdminUserId,
  addNewBox,
  isRefreshing = false,
}) => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const currentUser = FMDPStorage.get("current-user");
  const selectedAppId = FMDPStorage.get("selected-app-id");
  const dispatch = useDispatch();
  let globalDockAlign = useSelector((state) => state.common.globalDockAlign);

  const getUserId = () => {
    return getUserIdForFiltering(currentUser, selectedAppId);
  };

  //Set the non admin user id
  useEffect(() => {
    if (sortedDataDisplay) {
      setNonAdminUserId(getUserId());
    }
  }, []);

  const pagination = { page, perPage, onPageChange: setPage, onPerPageChange: setPerPage };

  useEffect(() => {
    setPage(1);
  }, [simpleSearch]);

  const {
    data: coreDevices = { data: [], total_count: 0 },
    error,
    isLoading,
  } = useGetVehiclesQuery(
    {
      page,
      per_page: perPage,
      q,
      filter_user_id: nonAdminUserId,
    },
    { skip: sortedDataDisplay }
  );

  const { data: devicesList } = useGetVehiclesQuery(
    {
      page,
      per_page: 10000,
      q,
      filter_user_id: nonAdminUserId,
      device_ids: sourceIds,
    },
    { skip: nonAdminUserId === "" }
  );

  const queryParams = nonAdminUserId
    ? {
        page,
        per_page: perPage,
        device_ids: sourceIds,
        q,
      }
    : {
        page,
        per_page: perPage,
        q,
      };

  const { data: devicesData = { data: [], total_count: 0 } } = useGetDevicesQuery(queryParams, {
    skip: sortedDataDisplay,
  });

  // If the user is non-admin, store the plate numbers which that particular user has
  useEffect(() => {
    if (nonAdminUserId) {
      FMDPStorage.set(
        "selected-plate-numbers",
        devicesList?.data?.map((device) => {
          return device?.plate_number;
        })
      );
    }

    if (devicesList?.data?.length > 0) {
      let temp = [];
      devicesList?.data?.map((device) => {
        temp.push(device?.device_name_list);
      });
      setSourceIds(temp);
    }
  }, [devicesList]);

  // For page change set the map as default tab
  useEffect(() => {
    setCurrentTab("Map");
    setShowTrack(false);
    setDockAlign("cross");
  }, [page]);

  useEffect(() => {
    if (!sortedDataDisplay) {
      try {
        list_arr = [];
        coreDevices?.data.forEach((element, index) => {
          let x = { className: element.device_name_list + "_cls" };
          list_arr.push({ ...element, ...x });
        });

        let tempDevices = [];

        coreDevices?.data?.map((device) => {
          if (device?.device_name_list) {
            let temp = device?.device_name_list?.split(",");
            tempDevices = temp.concat(tempDevices);
          }
        });

        devicesData?.data?.map((device) => {
          if (device?.device_id) {
            if (!tempDevices?.includes(device?.device_id)) {
              tempDevices.push(device?.device_id);
            }
          }
        });
        setSourceIds((prev) => tempDevices);
      } catch (e) {}
    }
  }, [coreDevices.data, devicesData?.data]);

  const onRowClick = (data) => {
    const uniqueId = `${data?.id}-${data?.plate_number}`;

    if (selectedRowId === uniqueId) {
      setSelectedRowId(null);
      removeLayerOnClose();
      setDetails(false);
      setDeviceId(null);
      setselectedVehiclePlate(null);
      setDockAlign("cross");
      setCurrentTab("Map");
      setVehicleData(null);
    } else {
      setSelectedRowId(uniqueId);
      setDetails(true);
      removeLayerOnClose();
      setDeviceId(data?.device_name_list || data?.device_id);
      setselectedVehiclePlate(data?.plate_number);
      setselectedDeviceName(data?.device_name_list);
      setVehicleData(data);
      /*  if (currentTab === "LiveTrack" || currentTab === "Map") {
        setCurrentTab("LiveTrack");
      } */
      try {
        showPontOnMap(data?.device_name_list, data?.plate_number);
      } catch (e) {}

      dockAlign === "cross" && setDockAlign(globalDockAlign);

      globalDockAlign === "pop-out" && addNewBox(100);
    }
  };

  useEffect(() => {
    try {
      if (!simpleSearch) {
        setSelectedRowId(null);
        removeLayerOnClose();
        setDetails(false);
        setDeviceId(null);
        setselectedVehiclePlate(null);
        setDockAlign("cross");
      }
    } catch (e) {
      console.log(e);
    }
  }, [paginationVehicles?.page, simpleSearch]);

  // Format time since last update for display
  const formatLastUpdated = (timestamp) => {
    if (!timestamp) return "N/A";

    const now = moment();
    const lastUpdate = moment(timestamp);
    const diffMinutes = now.diff(lastUpdate, "minutes");

    if (diffMinutes < 1) {
      return "Just now";
    } else if (diffMinutes < 60) {
      return `${diffMinutes}m ago`;
    } else {
      const diffHours = Math.floor(diffMinutes / 60);
      return `${diffHours}h ago`;
    }
  };

  const getHeaderList = () => {
    return (
      <header className="qi-list-view_header asset-list_header">
        <div className="qi-list-view_column status" title={getLocalizedString("status", "Status")}>
          {getLocalizedString("status", "Status")}
        </div>
        <div
          className="qi-list-view_column device-id"
          title={getLocalizedString("device_id", "Device ID")}
        >
          {getLocalizedString("device_id", "Device ID")}
        </div>
        <div
          className="qi-list-view_column device-name"
          title={getLocalizedString("device_name", "Device Name")}
        >
          {getLocalizedString("device_name", "Device Name")}
        </div>
        <div
          className="qi-list-view_column ignition-status"
          title={getLocalizedString("ignition", "Ignition")}
        >
          {getLocalizedString("ignition", "Ignition")}
        </div>
      </header>
    );
  };

  return (
    <>
      <MapViewFlyOut
        data={sortedDataDisplay ? data : devicesData?.data}
        setSelectedRange={setSelectionRange}
        pagination={
          sortedDataDisplay
            ? { ...paginationVehicles, count: totalCountVehicles }
            : { ...pagination, count: devicesData?.total_count }
        }
        error={error}
        highlight={highlight}
        setHighlight={setHighlight}
        setDockAlign={setDockAlign}
        setShowDetails={setShowDetails}
        removeLayerOnClose={removeLayerOnClose}
        setDeviceId={setDeviceId}
        setShowTrack={setShowTrack}
        simpleSearch={simpleSearch}
        selectedPage={"Devices"}
        title={getLocalizedString("devices", "Devices")}
        currentTab={currentTab}
        setselectedVehiclePlate={setselectedVehiclePlate}
        showPontOnMap={showPontOnMap}
        dockAlign={dockAlign}
        setDetails={setDetails}
        setSimpleSearch={setSimpleSearch}
        setMapExpand={setMapExpand}
        listType={"Vehicles"}
        isLoading={isLoading}
        search_by_message={getLocalizedString(
          "search_by_device_name_device_imei",
          "Device Name, Device IMEI, Plate No"
        )}
        getHeaderList={getHeaderList}
        setSortedDataDisplay={setSortedDataDisplay}
        sortedDataDisplay={sortedDataDisplay}
        setPage={setPage}
        setPageVehicles={setPageVehicles}
        isRefreshing={isRefreshing}
        formatLastUpdated={formatLastUpdated}
        deviceId={selectedRowId}
        isAutoRefreshPaused={Boolean(simpleSearch)}
      >
        <Scrollbars>
          <ListCard
            data={sortedDataDisplay ? data : devicesData?.data || []}
            cardType="Devices"
            onRowClick={onRowClick}
            highlight={highlight}
            setHighlight={setHighlight}
            selectedRowId={selectedRowId}
            mapData={mapData}
            sortedDataDisplay={sortedDataDisplay}
          />
        </Scrollbars>
      </MapViewFlyOut>
    </>
  );
};
